import { Component, Fragment, lazy, Suspense, type ReactNode } from 'react';
import ReactDOM from 'react-dom/client'

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  window.location.reload();
});
import './index.scss'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
const Signup = lazy(() => import('./firebase/signup.tsx'));

const Landingpagelayout = lazy(() => import('./pages/landinglayout.tsx'));
const Landing = lazy(() => import('./components/pages/landing/landing.tsx'));
const Joblanding = lazy(() => import('./components/pages/joblanding/joblanding.tsx'));
const Customer = lazy(() => import('./components/dashboard/customer/customer.tsx'));
const CustomerDBLayout = lazy(() => import('./pages/customerdblayout.tsx'));
const Error500 = lazy(() => import('./components/authentication/error/500-error/500-error.tsx'));
const Comingsoon = lazy(() => import('./components/authentication/coming-soon/coming-soon.tsx'));
const Cpbasic = lazy(() => import('./components/authentication/create-password/create-basic/create-basic.tsx'));
const Cpcover = lazy(() => import('./components/authentication/create-password/create-cover/create-cover.tsx'));
const Lsbasic = lazy(() => import('./components/authentication/lock-screen/lock-basic/lock-basic.tsx'));
const Lscover = lazy(() => import('./components/authentication/lock-screen/lock-cover/lock-cover.tsx'));
const Rpbasic = lazy(() => import('./components/authentication/reset-password/reset-basic/reset-basic.tsx'));
const Rpcover = lazy(() => import('./components/authentication/reset-password/reset-cover/reset-cover.tsx'));
const Subasic = lazy(() => import('./components/authentication/sign-up/sign-up-basic/sign-up-basic.tsx'));
const Sucover = lazy(() => import('./components/authentication/sign-up/sign-up-cover/sign-up-cover.tsx'));
const Tsvbasic = lazy(() => import('./components/authentication/two-step-verification/twostep-basic/twostep-basic.tsx'));
const Tsvcover = lazy(() => import('./components/authentication/two-step-verification/twostep-cover/twostep-cover.tsx'));
const Undermaintainance = lazy(() => import('./components/authentication/under-maintainance/under-maintainance.tsx'));
const Error401 = lazy(() => import('./components/authentication/error/401-error/401-error.tsx'));
const Error404 = lazy(() => import('./components/authentication/error/404-error/404-error.tsx'));
const Firebaselayout = lazy(() => import('./pages/firebaselayout.tsx'));
const CaresHomepage = lazy(() => import('./components/cares/cares-homepage.tsx'));
import CaresLogin from './components/cares/cares-login.tsx';
import CaresForgotPassword from './components/cares/cares-forgot-password.tsx';
import CaresResetPassword from './components/cares/cares-reset-password.tsx';
import CaresSignup from './components/cares/cares-signup.tsx';
import App from './pages/App.tsx';
import { Provider } from 'react-redux';
import RootWrapper from './pages/rootwrapper.tsx';
import Forgetpassword from './firebase/forgetpassword.tsx';
import { caresRouteData } from './shared/common/ui/cares-routingdata.tsx';
import { RouteData } from './shared/common/ui/routingdata.tsx';
import store from './shared/common/ui/redux/store.tsx';

const routePath = (path?: string) => {
  const baseUrl = import.meta.env.BASE_URL ?? '';

  return (path ?? '').replace(baseUrl, '').replace(/^\/+/, '');
};

class RuntimeErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    console.error('CARES React render error', this.state.error);

    return null;
  }
}

const rootElement = document.getElementById('root')!;

if (window.location.pathname === '/') {
  rootElement.innerHTML = `
    <main class="coming-soon-main">
      <section class="authentication coming-soon d-flex align-items-center justify-content-center min-vh-100 text-center px-4">
        <div class="authentication-cover" style="max-width:720px">
          <div class="aunthentication-cover-content text-center">
            <p class="fs-12 mb-1 text-muted">CARES PLATFORM</p>
            <h1 class="mb-3">CARES is live</h1>
            <p class="mb-4">CARES helps authorized staff manage schedules, requests, and client coordination in one place. Sign in to access your workspace.</p>
            <div class="d-grid gap-2 mb-5">
              <a href="/login" class="btn btn-lg btn-primary">Login</a>
            </div>
          </div>
        </div>
      </section>
      <footer class="footer mt-auto py-3 ps-0 text-default text-center authentication-footer position-absolute bottom-0 w-100">
        <div class="d-flex align-items-center justify-content-sm-between justify-content-center px-4 flex-wrap gap-3">
          <span class="text-muted">Copyright © ${new Date().getFullYear()} <a href="/" class="text-dark">CARES</a> Platform</span>
        </div>
      </footer>
    </main>
  `;
} else {
ReactDOM.createRoot(rootElement).render(
  <Fragment>
    {/* <HelmetProvider> */}
    <RuntimeErrorBoundary>
      <Suspense fallback={null}>
        <Provider store={store}>
          <RootWrapper>
            {window.location.pathname === '/' ? (
              <CaresHomepage />
            ) : (
            <BrowserRouter>
            {/* <Scrolltotop /> */}
            <Routes>

              <Route path='/' element={<Firebaselayout />}>
              <Route path='common/firebase/signin' element={<Navigate to="/login" replace />} />
              <Route path='common/firebase/signup' element={<Signup />} />
              <Route path='common/firebase/forgetpassword' element={<Forgetpassword />} />
            </Route>

              <Route path='/' element={<App />}>
                {caresRouteData
                  .filter((idx) => typeof idx.path === 'string' && idx.path !== '')
                  .map((idx) => (
                    <Route key={idx.id} path={routePath(idx.path)} element={idx.element} />
                  ))}
                {RouteData
                  .filter((idx) => typeof idx.path === 'string' && idx.path !== '')
                  .map((idx) => (
                    <Route key={idx.id} path={routePath(idx.path)} element={idx.element} />
                  ))}
              </Route>

              <Route path='/' element={<Landingpagelayout />}>
                <Route path='pages/landing' element={<Landing />} />
                <Route path='pages/joblanding' element={<Joblanding />} />
              </Route>

              <Route path='/' element={<CustomerDBLayout />}>
                <Route path='dashboards/customer' element={<Customer />} />
              </Route>

              <Route index element={<CaresHomepage />} />
              <Route path='login' element={<CaresLogin />} />
              <Route path='forgot-password' element={<CaresForgotPassword />} />
              <Route path='reset-password' element={<CaresResetPassword />} />
              <Route path='reset-password/:token' element={<CaresResetPassword />} />
              <Route path='signup' element={<CaresSignup />} />
              <Route path='authentication/coming-soon' element={<Comingsoon />} />
              <Route path='authentication/createpassword/create-password-basic' element={<Cpbasic />} />
              <Route path='authentication/createpassword/create-password-cover' element={<Cpcover />} />
              <Route path='authentication/lockscreen/lockscreen-basic' element={<Lsbasic />} />
              <Route path='authentication/lockscreen/lockscreen-cover' element={<Lscover />} />
              <Route path='authentication/resetpassword/reset-password-basic' element={<Rpbasic />} />
              <Route path='authentication/resetpassword/reset-password-cover' element={<Rpcover />} />
              <Route path='authentication/signin/sign-in-basic' element={<Navigate to="/login" replace />} />
              <Route path='authentication/signin/sign-in-cover' element={<Navigate to="/login" replace />} />
              <Route path='authentication/signup/sign-up-basic' element={<Subasic />} />
              <Route path='authentication/signup/sign-up-cover' element={<Sucover />} />
              <Route path='authentication/twostepverification/two-step-verification-basic' element={<Tsvbasic />} />
              <Route path='authentication/twostepverification/two-step-verification-cover' element={<Tsvcover />} />
              <Route path='authentication/under-maintenance' element={<Undermaintainance />} />
              <Route path='error/error401' element={<Error401 />} />
              <Route path='error/error404' element={<Error404 />} />
              <Route path='error/error500' element={<Error500 />} />
            </Routes>
            </BrowserRouter>
            )}
          </RootWrapper>
        </Provider>
      </Suspense>
    </RuntimeErrorBoundary>
    {/* </HelmetProvider> */}
  </Fragment>
);
}
